import { getMetaDossierList, getMetaCollectionList, addFeatureWork, updateFeatureWork, getDonarProfile } from '@/libs/api/api'
import {message, errorHandler, logout, loader} from '@/libs/helper'
import InfiniteLoading from 'vue-infinite-loading';
import {concat, uniq} from 'lodash'
import constants from '@/libs/constant/constants'
import { mapGetters } from 'vuex'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'DonationProfile',
    components: {InfiniteLoading},
    data() {
        return {
            des: {
                donor_short_description: '',
                donor_biography: ''
            },
            columns: ['name', 'type', 'statistics'],
            tableSettings: {
                headings: {
                  name: 'Name',
                  type:"Type",
                  statistics:'Statistics',
                },
                perPage: 5,
                filterable: [],
                filterByColumn: true,
            },
            tableData : [],
            showPopup: false,
            collectionList: [],
            isLoadMore: true,
            isFetchingCollections: false,
            dossierList: [],
            isFetchingDossiers: false,
            isLoadMoreDossiers: true,
            skip: 0,
            limit: 30,
            dossierSkip: 0,
            collectionIds: [],
            dossierIds: [],
            donationProfile: {},
            loading:false,
            permissions: permissions
        }
    },

    computed: {
        ...mapGetters(['hasPermission']),
        isDisabledCollections () {
            return !this.isLoadMore || this.isFetchingCollections
        },
        isDisabledDossiers () {
            return !this.isLoadMoreDossiers || this.isFetchingDossiers
        }
    },

    async mounted() {
        this.loading=true
        await this.getDonationProfile()
        this.loading=false
    },

    props: {
        selectedValue: {
            type: Object,
            default: () => {}
        },
    },
    watch: {
        selectedValue () {
            this.getDonationProfile()
        }
    },

    methods: {

        saveFormData () {
            this.$refs['donation-profile'].validate(async(isValid) => {
                if(!this.hasPermission(permissions.updateFeatureWork)) return;
                if (!isValid) return
                try {
                    loader(this, true)
                    let body = {
                        donor_short_description: this.des.donor_short_description,
                        donor_biography: this.des.donor_biography,
                    }
                    let response
                    if (this.donationProfile && this.donationProfile._id) {
                        body.document_id = this.donationProfile._id
                        response = await updateFeatureWork(body)
                    } else {
                        body.entity_id = this.$route.params.id,
                        body.entity_type = this.$route.params.type.toUpperCase()
                        response = await addFeatureWork(body) 
                    }
                    // set response
                    this.setProfileResponse(response)
                    await this.getDonationProfile()
                    message(this, constants.messageType.SUCCESS, 'Profile added Successfully');
                } catch (error) {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                }
                loader(this, false)
            })
        },

        /**
         * close popup
         */
        closePopup () {
            this.showPopup = false
            this.skip = 0
            this.dossierSkip = 0
        },

        /**
         * show popup 
         */
        openPopup () {
            this.showPopup = true
            // fetch collections
            this.fetchCollections()
            // fetch dossiers
            this.fetchDossiers()
        },
        /**
         * infinite loading handler collection
         */
        handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMore) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },

        /**
         *  to fetch the collections
         */
        fetchCollections (isLoadMore) {
            this.isFetchingCollections = true
            // paarams for api
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            // body for api
            let body = {
                entity_type: this.$route.params.type && this.$route.params.type.toUpperCase(),
                entity_id: this.$route.params.id
            }
            // api call
            getMetaCollectionList(body, params)
            .then(response => {
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else this.collectionList = response.items || []
                // increase the skip
                this.skip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMore = false
                }
                // to make fetching false
                this.isFetchingCollections = false
            })
            .catch(() => {
                this.clearFields()
            })
        },

        /**
         * to fetch collections 
         */
        async fetchDossiers (isLoadMore) {
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: this.$route.params.type && this.$route.params.type.toUpperCase(),
                    entity_id: this.$route.params.id
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                this.isLoadMoreDossiers = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },

        /**
         * select featured collections
         */
        selectFeaturedCollections (event, type, list) {
            // for collection
            if (type === constants.LIST.COLLECTION) {
                let collectionIds = [...this.collectionIds]
                if (event) collectionIds.push(list._id)
                else collectionIds = collectionIds.filter(id => id !== list._id)
                this.collectionIds = uniq(collectionIds)
            } 
            
            // for dossier
            else {
                let dossierIds = [...this.dossierIds]
                if (event) dossierIds.push(list._id)
                else dossierIds = dossierIds.filter(id => id !== list._id)
                this.dossierIds = uniq(dossierIds)
            }
        },
        
        /**
         * add featured work
         */
        async addFeatureCollection () {
            if(!this.hasPermission(permissions.updateFeatureWork)) return;
            try {
                loader(this, true)
                let body = {
                    collection_ids: this.collectionIds,
                    dossier_ids: this.dossierIds
                }
                let response
                if (this.donationProfile && this.donationProfile._id) {
                    body.document_id = this.donationProfile._id
                    response = await updateFeatureWork(body)
                } else {
                    body.entity_id = this.$route.params.id,
                    body.entity_type = this.$route.params.type.toUpperCase()
                    response = await addFeatureWork(body) 
                }
                this.setProfileResponse(response)
                this.closePopup()
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            loader(this, false)
        },

        /**
         * fetch donation profile
         */
        async getDonationProfile () {
            if(!this.hasPermission(permissions.getDonarProfile)) return;
            // body
            let body = {
                entity_type: this.$route.params.type && this.$route.params.type.toUpperCase(),
                entity_id: this.$route.params.id
            }
            await getDonarProfile(body)
            .then(response => {
                this.setProfileResponse(response)
            })
            .catch(error => {
                console.error(error)
            })
        },

        /**
         * set response
         */
        setProfileResponse (profile) {
            this.donationProfile = profile || {}
            this.des = {
                donor_short_description: profile.donor_short_description || '',
                donor_biography: profile.donor_biography || ''
            }
            this.tableData = concat((profile.collections || []), (profile.regulardossiers || []))
            this.collectionIds = profile.collection_ids || []
            this.dossierIds = profile.dossier_ids || []
        },

        /**
         * when not to save the description and intro fields
         */
        cancelProfileSave () {
            if (this.des.donor_short_description !== this.donationProfile.donor_short_description || this.des.donor_biography !== this.donationProfile.donor_biography) {
                this.des = {
                    donor_short_description: this.donationProfile.donor_short_description || '',
                    donor_biography: this.donationProfile.donor_biography || ''
                }
            }
        }
    }
}